'use client';
import React, { useState, useEffect } from 'react';

/**
 * Fades in instantly when `loading = true`,
 * and fades out smoothly when `loading = false`.
 */
export function LoaderOverlay({ loading }: { loading: boolean }) {
  // Keep track of whether the overlay should be visible in the DOM
  const [visible, setVisible] = useState(loading);

  useEffect(() => {
    if (loading) {
      // If we switch from not loading -> loading,
      // show the overlay immediately
      setVisible(true);
    } else {
      // If we switch from loading -> not loading,
      // wait for the fade-out transition to finish
      const timeout = setTimeout(() => {
        setVisible(false);
      }, 300); // match transition duration in the CSS
      return () => clearTimeout(timeout);
    }
  }, [loading]);

  // If not loading and the fade-out transition finished, remove from DOM
  if (!loading && !visible) {
    return null;
  }

  return (
    <div
      className={`
       fixed inset-0 z-50 top-0
        flex items-center justify-center
        bg-black/30
        transition-opacity duration-300 ease-in-out
        ${loading ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'}
      `}
    >
      {/* A Tailwind-based circular loader */}
      <div className="h-6 w-6 border-4 border-black border-t-transparent rounded-full animate-spin" />
    </div>
  );
}
